export const Countries = [
  'UNITED STATES',
  'AFGHANISTAN',
  'ALBANIA',
  'ALGERIA',
  'AMERICAN SAMOA',
  'ANDORRA',
  'ANGOLA',
  'ANGUILLA',
  'ANTARCTICA',
  'ANTIGUA AND BARBUDA',
  'ARGENTINA',
  'ARMENIA',
  'ARUBA',
  'AUSTRALIA',
  'AUSTRIA',
  'AZERBAIJAN',
  'BAHAMAS',
  'BAHRAIN',
  'BANGLADESH',
  'BARBADOS',
  'BELARUS',
  'BELGIUM',
  'BELIZE',
  'BENIN',
  'BERMUDA',
  'BHUTAN',
  'BOLIVIA',
  'BOSNIA AND HERZEGOWINA',
  'BOTSWANA',
  'BOUVET ISLAND',
  'BRAZIL',
  'BRITISH INDIAN OCEAN TERRITORY',
  'BRUNEI DARUSSALAM',
  'BULGARIA',
  'BURKINA FASO',
  'BURUNDI',
  'CAMBODIA',
  'CAMEROON',
  'CANADA',
  'CAPE VERDE',
  'CAYMAN ISLANDS',
  'CENTRAL AFRICAN REPUBLIC',
  'CHAD',
  'CHILE',
  'CHINA',
  'CHRISTMAS ISLAND',
  'COCOS (KEELING) ISLANDS',
  'COLOMBIA',
  'COMOROS',
  'CONGO',
  'COOK ISLANDS',
  'COSTA RICA',
  `COTE D' IVOIRE`,
  'CROATIA (local name: Hrvatska)',
  'CUBA',
  'CYPRUS',
  'CZECH REPUBLIC',
  'DENMARK',
  'DJIBOUTI',
  'DOMINICA',
  'DOMINICAN REPUBLIC',
  'TIMOR-LESTE',
  'ECUADOR',
  'EGYPT',
  'EL SALVADOR',
  'EQUATORIAL GUINEA',
  'ERITREA',
  'ESTONIA',
  'ETHIOPIA',
  'FALKLAND ISLANDS (MALVINAS)',
  'FAROE ISLANDS',
  'FIJI',
  'FINLAND',
  'FRANCE',
  'FRANCE METROPOLITAN',
  'FRENCH GUIANA',
  'FRENCH POLYNESIA',
  'FRENCH SOUTHERN TERRITORIES',
  'GABON',
  'GAMBIA',
  'GEORGIA',
  'GERMANY',
  'GHANA',
  'GIBRALTAR',
  'GREECE',
  'GREENLAND',
  'GRENADA',
  'GUADELOUPE',
  'GUAM',
  'GUATEMALA',
  'GUINEA',
  'GUINEA-BISSAU',
  'GUYANA',
  'HAITI',
  'HEARD AND MC DONALD ISLANDS',
  'HONDURAS',
  'HONG KONG',
  'HUNGARY',
  'ICELAND',
  'INDIA',
  'INDONESIA',
  'IRAN (ISLAMIC REPUBLIC OF)',
  'IRAQ',
  'IRELAND',
  'ISRAEL',
  'ITALY',
  'JAMAICA',
  'JAPAN',
  'JORDAN',
  'KAZAKHSTAN',
  'KENYA',
  'KIRIBATI',
  `KOREA DEMOCRATIC PEOPLE'S REPUBLIC OF`,
  'KOREA REPUBLIC OF',
  'KUWAIT',
  'KYRGYZSTAN',
  `LAO PEOPLE'S DEMOCRATIC REPUBLIC`,
  'LATVIA',
  'LEBANON',
  'LESOTHO',
  'LIBERIA',
  'LIBYAN ARAB JAMAHIRIYA',
  'LIECHTENSTEIN',
  'LITHUANIA',
  'LUXEMBOURG',
  'MACAU',
  'MACEDONIA',
  'MADAGASCAR',
  'MALAWI',
  'MALAYSIA',
  'MALDIVES',
  'MALI',
  'MALTA',
  'MARSHALL ISLANDS',
  'MARTINIQUE',
  'MAURITANIA',
  'MAURITIUS',
  'MAYOTTE',
  'MEXICO',
  'MICRONESIA',
  'MOLDOVA',
  'MONACO',
  'MONGOLIA',
  'MONTSERRAT',
  'MOROCCO',
  'MOZAMBIQUE',
  'MYANMAR',
  'NAMIBIA',
  'NAURU',
  'NEPAL',
  'NETHERLANDS',
  'NETHERLANDS ANTILLES',
  'NEW CALEDONIA',
  'NEW ZEALAND',
  'NICARAGUA',
  'NIGER',
  'NIGERIA',
  'NIUE',
  'NORFOLK ISLAND',
  'NORTHERN MARIANA ISLANDS',
  'NORWAY',
  'OMAN',
  'PAKISTAN',
  'PALAU',
  'PANAMA',
  'PAPUA NEW GUINEA',
  'PARAGUAY',
  'PERU',
  'PHILIPPINES',
  'PITCAIRN',
  'POLAND',
  'PORTUGAL',
  'PUERTO RICO',
  'QATAR',
  'REUNION',
  'ROMANIA',
  'RUSSIAN FEDERATION',
  'RWANDA',
  'SAINT KITTS AND NEVIS',
  'SAINT LUCIA',
  'SAINT VINCENT AND THE GRENADINES',
  'SAMOA',
  'SAN MARINO',
  'SAO TOME AND PRINCIPE',
  'SAUDI ARABIA',
  'SENEGAL',
  'SEYCHELLES',
  'SIERRA LEONE',
  'SINGAPORE',
  'SLOVAKIA (Slovak Republic)',
  'SLOVENIA',
  'SOLOMON ISLANDS',
  'SOMALIA',
  'SOUTH AFRICA',
  'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
  'SPAIN',
  'SRI LANKA',
  'ST. HELENA',
  'ST. PIERRE AND MIQUELON',
  'SUDAN',
  'SURINAME',
  'SVALBARD AND JAN MAYEN ISLANDS',
  'SWAZILAND',
  'SWEDEN',
  'SWITZERLAND',
  'SYRIAN ARAB REPUBLIC',
  'TAIWAN',
  'TAJIKISTAN',
  'TANZANIA UNITED REPUBLIC OF',
  'THAILAND',
  'TOGO',
  'TOKELAU',
  'TONGA',
  'TRINIDAD AND TOBAGO',
  'TUNISIA',
  'TURKEY',
  'TURKMENISTAN',
  'TURKS AND CAICOS ISLANDS',
  'TUVALU',
  'UGANDA',
  'UKRAINE',
  'UNITED ARAB EMIRATES',
  'UNITED KINGDOM',
  'UNITED STATES MINOR OUTLYING ISLANDS',
  'URUGUAY',
  'UZBEKISTAN',
  'VANUATU',
  'VATICAN CITY STATE (HOLY SEE)',
  'VENEZUELA',
  'VIET NAM',
  'VIRGIN ISLANDS (BRITISH)',
  'VIRGIN ISLANDS (U.S.)',
  'WALLIS AND FUTUNA ISLANDS',
  'WESTERN SAHARA',
  'YEMEN',
  'YUGOSLAVIA',
  'CONGO',
];
export const UsStates = [
  'ALABAMA',
  'ALASKA',
  'ARIZONA',
  'ARKANSAS',
  'CALIFORNIA',
  'COLORADO',
  'CONNECTICUT',
  'DELAWARE',
  'DISTRICT OF COLUMBIA',
  'FLORIDA',
  'GEORGIA',
  'HAWAII',
  'IDAHO',
  'ILLINOIS',
  'INDIANA',
  'IOWA',
  'KANSAS',
  'KENTUCKY',
  'LOUISIANA',
  'MAINE',
  'MARYLAND',
  'MASSACHUSETTS',
  'MICHIGAN',
  'MINNESOTA',
  'MISSISSIPPI',
  'MISSOURI',
  'MONTANA',
  'NEBRASKA',
  'NEVADA',
  'NEW HAMPSHIRE',
  'NEW JERSEY',
  'NEW MEXICO',
  'NEW YORK',
  'NORTH CAROLINA',
  'NORTH DAKOTA',
  'OHIO',
  'OKLAHOMA',
  'OREGON',
  'PENNSYLVANIA',
  'RHODE ISLAND',
  'SOUTH CAROLINA',
  'SOUTH DAKOTA',
  'TENNESSEE',
  'TEXAS',
  'UTAH',
  'VERMONT',
  'VIRGINIA',
  'WASHINGTON',
  'WEST VIRGINIA',
  'WISCONSIN',
  'WYOMING',
];
export const AlienNumberPrefixes = ['AR', 'USCIS', 'I94'];
export const RaceOptions = [
  'American Indian or Alaska Native',
  'Asian',
  'Black or African American',
  'Native Hawaiian or Other Pacific Islander',
  'White',
];
export const SexOptions = ['Male', 'Female', 'Non-Binary'];
export const EthnicityOptions = [
  'Is Hispanic or Latino',
  'Is Not Hispanic or Latino',
];
export const Instructions = [
  {
    question: '9',
    title: `Transferee’s/Buyers Full Name:`,
    body: `If the transferee’s/buyer’s name is 
illegible, the transferor/seller must print the transferee’s/buyer’s name above the Page 4 of 7 
name written by the transferee/buyer.`,
  },
  {
    question: '10',
    title: `Current Residence Address:`,
    body: `A rural route (RR) may be accepted 
provided the transferee/buyer lives in a State or locality where it is considered a 
legal residence address. If the transferee/buyer is a member of the Armed Forces on 
active duty, his/her State of residence is the State in which his/her permanent duty 
station is located. If the service member is acquiring a firearm in a State where his/
her permanent duty station is located, but resides in a different State, the transferee/
buyer must list both his/her permanent duty station address and residence address. 
In these instances, the Armed Forces member must answer “Reside in city limits?” 
only for their residence address. 
If the transferee/buyer has two States of residence, the transferee/buyer should list 
his/her current residence address (e.g., if the transferee/buyer is purchasing a firearm 
while staying at his/her weekend home in State X, list the address in State X)`,
  },
  {
    question: '14',
    title: `Sex:`,
    body: `Individuals with neither male nor female on their identification 
document(s) should check Non-Binary.`,
  },
  {
    question: '17',
    title: `Unique Personal Identification Number (UPIN) or Appeals 
Management Database Identification (AMD ID):`,
    body: `For transferees/buyers 
approved to have information maintained about them in the FBI NICS Voluntary 
Appeal File, NICS will provide them with a UPIN, which the transferee/buyer 
should record in question 17. The AMD ID is a number that will be provided to an 
appellant on certain types of overturned appeals and should also be recorded in 
question 17. The transferor/seller should provide the UPIN/AMD ID when 
conducting background checks through the NICS or the State POC.`,
  },
  {
    question: '18a',
    title: `Ethnicity and Race:`,
    body: `Federal regulations (27 CFR 478.124(c)(1)) require licensees 
to obtain the race of the transferee/buyer. This information helps the FBI and/or State 
POC make or rule out potential matches during the background check process and can 
assist with criminal investigations.
<br>
<b>Ethnicity</b> refers to a person’s heritage. Persons of Cuban, Mexican, Puerto Rican, 
South or Central American, or other Spanish culture or origin, regardless of race, are 
considered Hispanic or Latino.
<br>
<b>Race</b> - one or more of the following responses must be selected: (1) American 
Indian or Alaska Native - A person having origins in any of the original peoples of 
North and South America (including Central America), and who maintains an 
affiliation or community attachment; (2) Asian - A person having origins in any 
of the original peoples of the Far East, Southeast Asia, or the Indian subcontinent 
including, for example, Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, 
the Philippine Islands, Thailand, and Vietnam; (3) Black or African American - A
person having origins in any of the Black racial groups of Africa; (4) Native Hawaiian
or Other Pacific Islander - A person having origins in any of the original peoples of 
Hawaii, Guam, Samoa, or other Pacific Islands; and/or (5) White - A person having 
origins in any of the original peoples of Europe, the Middle East, or North Africa. 
Select the closest representation for any other race or ethnicity that does not fall 
within those indicated.`,
  },
  {
    question: '20',
    title: `U.S.-issued Alien Number or Admission Number:`,
    body: `U.S.-issued 
alien and admission numbers may be found on the following U.S. Department of 
Homeland Security documents: Legal Resident Card or Employment Authorization 
Card (AR# or USCIS#); Arrival/Departure Record, Form I94, or Form 797A (I94#). 
Additional information can be obtained from www.cbp.gov. If you are a U.S. citizen 
or U.S. national, the response to this question should be left blank.`,
  },
  {
    question: '21a',
    title: `Actual Transferee/Buyer:`,
    body: `For purposes of this form, a person is the actual transferee/buyer if 
    he/she is purchasing the firearm for him/herself or otherwise acquiring the 
    firearm for him/herself. (e.g., redeeming the firearm from pawn, retrieving 
    it from consignment, firearm raffle winner). A person is also the actual 
    transferee/buyer if he/she is legitimately purchasing the firearm as a bona 
    fide gift for a third party. A gift is not bona fide if another person 
    offered or gave the person completing this form money, service(s), or 
    item(s) of value to acquire the firearm for him/her, or if the other 
    person is prohibited by law from receiving or possessing the firearm.
    <br>
    <br>
    <b>EXAMPLES:</b> Mr. Smith asks Mr. Jones to purchase a firearm for Mr. Smith 
    (who may or may not be prohibited). Mr. Smith gives Mr. Jones the money 
    for the firearm. Mr. Jones is NOT THE ACTUAL TRANSFEREE/BUYER of the 
    firearm and must answer “no” to question 21.a. The licensee may not 
    transfer the firearm to Mr. Jones. However, if Mr. Brown buys the firearm
    with his own money to give to Mr. Black as a gift (with no service or 
    tangible thing of value provided by Mr. Black), Mr. Brown is the actual 
    transferee/buyer of the firearm and should answer “yes” to question 21.a.
    However, the transferor/seller may not transfer a firearm to any person 
    he/she knows or has reasonable cause to believe is prohibited under 
    18 U.S.C. 922(g), (h), (n), or (x).`,
  },
  {
    question: '21b',
    title: `Prohibited Persons:`,
    body: `Generally, 18 U.S.C. 922(g) prohibits the shipment, transportation, receipt,
    or possession in or affecting interstate commerce of a firearm by one who: has been
    convicted of a felony in any Federal, including a general court-martial, State or
    local court, or any other crime, punishable by imprisonment for a term exceeding one
    year; is a fugitive from justice; is an unlawful user of, or addicted to, marijuana
    or any depressant, stimulant, or narcotic drug, or any other controlled substance;
    has been adjudicated as a mental defective or has been committed to a mental
    institution; has been discharged from the Armed Forces under dishonorable conditions;
    is subject to certain restraining orders; convicted of a misdemeanor crime of domestic
    violence under Federal, including a general court-martial, State or Tribal law; has
    renounced his/her U.S. citizenship; is an alien illegally in the United States or an
    alien admitted to the United States under a nonimmigrant visa. Furthermore, section
    922(n) prohibits the shipment, transportation, or receipt in or affecting interstate
    commerce of a firearm by one who is under indictment or information for a felony in
    any Federal, including a general court-martial, State or local court, or any other
    crime, punishable by imprisonment for a term exceeding one year. An information is a
    formal accusation of a crime verified by a prosecutor.
    <br>
    <br>
    A member of the Armed Forces must answer “yes” to 21.b. if charged with an offense
    that is referred to a general court-martial. A current or former member of the Armed
    Forces must answer “yes” to 21.c. if convicted under a general court-martial.
    <br>
    <br>
    Discharged “under dishonorable conditions” means separation from the Armed Forces
    resulting from a dishonorable discharge or dismissal adjudged by a general court-martial.
    That term does not include any other discharge or separation.
    <br>
    <br>
    <b>EXCEPTION:</b> A person is not prohibited from receiving or possessing a firearm if that
    person: (1) has been convicted of any Federal or State offense pertaining to antitrust
    violations, unfair trade practices, restraints of trade, or other similar offenses
    relating to the regulation of business practices; (2) has been convicted of a State
    misdemeanor punishable by imprisonment of two years or less; or (3) following conviction
    of a felony or other crime for which the judge could have imprisoned the person for
    more than one year, or a misdemeanor crime of domestic violence, has received a pardon,
    an expungement or set aside of the conviction, or has lost and regained civil rights 
    (the right to vote, sit on a jury, and hold public office) in the jurisdiction in which
    the conviction occurred, AND the law of the convicting jurisdiction does not prohibit
    the person from receiving or possessing firearms. Person subject to any of these
    exceptions, or who received relief from disabilities under 18 U.S.C. 925(c), should
    answer “no” to the applicable question.`,
  },
  {
    question: '21d',
    title: `Fugitive from Justice:`,
    body: `Any person who has fled from any State to avoid prosecution for a felony or a misdemeanor;
    or any person who leaves the State to avoid giving testimony in any criminal proceeding. The
    term also includes any person who knows that misdemeanor or felony charges are pending against
    such person and who leaves the State of prosecution.`,
  },
  {
    question: '21f',
    title: `Adjudicated as a Mental Defective:`,
    body: `A determination by a court, board, commission, or other lawful authority that a
    person, as a result of marked subnormal intelligence, or mental illness, incompetency,
    condition, or disease: (1) is a danger to himself or to others; or (2) lacks the mental
    capacity to contract or manage his own affairs. This term shall include: (1) a finding of
    insanity by a court in a criminal case; and (2) those persons found incompetent to stand
    trial or found not guilty by reason of lack of mental responsibility.
    <br>
    <br>
    <b>Committed to a Mental Institution:</b> A formal commitment of a person to a mental institution
    by a court, board, commission, or other lawful authority. The term includes a commitment
    to a mental institution involuntarily. The term includes commitment for mental defectiveness
    or mental illness. It also includes commitments for other reasons, such as for drug use.
    The term does not include a person in a mental institution for observation or a voluntary
    admission to a mental institution.
    <br>
    <br>
    <b>EXCEPTION:</b> Under the NICS Improvement Amendments Act of 2007, a person who has been
    adjudicated as a mental defective or committed to a mental institution in a State
    proceeding is not prohibited by the adjudication or commitment if the person has been
    granted relief by the adjudicating/committing State pursuant to a qualifying mental
    health relief from disabilities program. Also, a person who has been adjudicated as
    a mental defective or committed to a mental institution by a department or agency of
    Federal Government is not prohibited by the adjudication or commitment if either: (a)
    the person’s adjudication or commitment was set aside or expunged by the adjudicating/committing
    agency; (b) the person has been fully released or discharged from all mandatory treatment,
    supervision, or monitoring by the agency; (c) the person was found by the agency to no longer
    suffer from the mental health condition that served as the basis of the initial adjudication/commitment;
    (d) the adjudication or commitment, respectively, is based solely on a medical finding of disability,
    without an opportunity for a hearing by a court, board, commission, or other lawful authority,
    and the person has not been adjudicated as a mental defective consistent with section 922(g)(4)
    of title 18, United States Code; or (e) the person was granted relief from the adjudicating/committing
    agency pursuant to a qualified mental health relief from disabilities program. This exception
    to an adjudication or commitment by a Federal department or agency does not apply to any person
    who was adjudicated to be not guilty by reason of insanity, or based on lack of mental responsibility,
    or found incompetent to stand trial, in any criminal case or under the Uniform Code of Military
    Justice. Persons who fall within one of the above exceptions should answer “no” to question 21.f.`,
  },
  {
    question: '21h',
    title: `Qualifying Restraining Orders:`,
    body: `Under 18 U.S.C. 922, firearms may not be sold to or received by persons subject to a court 
    order that: (A) was issued after a hearing which the person received actual notice of and had an 
    opportunity to participate in; (B) restrains such person from harassing, stalking, or threatening 
    an intimate partner or child of such intimate partner or person, or engaging in other conduct that 
    would place an intimate partner in reasonable fear of bodily injury to the partner or child; and 
    (C)(i) includes a finding that such person represents a credible threat to the physical safety of 
    such intimate partner or child; or (ii) by its terms explicitly prohibits the use, attempted use, 
    or threatened use of physical force against such intimate partner or child that would reasonably 
    be expected to cause bodily injury. An “intimate partner” of a person is: the spouse or former 
    spouse of the person, the parent of a child of the person, or an individual who cohabitates or 
    has cohabitated with the person.`,
  },
  {
    question: '21i',
    title: ` Misdemeanor Crime of Domestic Violence:`,
    body: `A Federal, including a general court-martial, State, local, or tribal offense that is a
    misdemeanor under Federal, State, or tribal law and has, as an element, the use or attempted use of
    physical force, or the threatened use of a deadly weapon, committed by a current or former spouse,
    parent, or guardian of the victim, by a person with whom the victim shares a child in common, by a
    person who is cohabitating with, or has cohabited with the victim as a spouse, parent, or guardian,
    or by a person similarly situated to a spouse, parent, or guardian of the victim. The term includes
    all misdemeanors that have as an element the use or attempted use of physical force or the threatened
    use of a deadly weapon (e.g., assault and battery), if the offense is committed by one of the defined
    parties. (See Exception to 21.b. - 21.l.) A person who has been convicted of a misdemeanor crime of
    domestic violence also is not prohibited unless: (1) the person was represented by a lawyer or gave
    up the right to a lawyer; or (2) if the person was entitled to a jury, was tried by a jury, or gave
    up the right to a jury trial. Persons subject to this exception should answer “no” to 21.i.
    <br>
    <br>
    A current or former member of the military who has been convicted of a violation of the Uniform Code
    of Military Justice that included, as an element, the use of force against a person as identified in
    the instructions under question 21.i. must answer “yes” to this question. This may include a qualifying
    offense that was referred to a special or general court-martial.`,
  },
  {
    question: '21l',
    title: `Immigration Status:`,
    body: `An alien admitted to the United States under a nonimmigrant visa includes, among others,
    persons visiting the United States temporarily for business or pleasure, persons studying in the
    United States who maintain a residence abroad, and certain temporary foreign workers. These
    aliens must answer “yes” to this question and provide the additional documentation as required
    under question 26.d.to establish they are excepted from the nonimmigrant alien prohibition.
    Permanent resident aliens and aliens legally admitted to the United States pursuant to either the
    Visa Waiver Program or to regulations otherwise exempting them from visa requirements may answer
    “no” to this question, leave 21.l.2 blank and are not required to submit the additional documentation 
    under question 26.d.`,
  },
  {
    question: '24',
    title: `Category of Firearm(s):`,
    body: `“Other” refers to frames, receivers, and other firearms that are neither handguns nor long guns
     (rifles or shotguns), such as firearms having a pistol grip that expel a shotgun shell, or National 
     Firearms Act (NFA) firearms, including silencers.
    <br>
    <br>
    If a frame or receiver can only be made into a LONG GUN (i.e., RIFLE OR SHOTGUN), it is still a frame
    or receiver, not a handgun or long gun. All frames and receivers are “firearms” by definition, and
    subject to the same GCA limitations. See 18 U.S.C 921(a)(3)(B). 18 U.S.C 922(b)(1) makes it unlawful
    for a licensee to sell any firearm other than a shotgun or rifle to any person under the age of 21.
    Since a frame or receiver for a firearm, to include one that can only be made into a long gun, is a 
    “firearm other than a shotgun or rifle,” it cannot be transferred to anyone under the age of 21,
    nor can these firearms be transferred to anyone who is not a resident of the State where the transfer
    is to take place. Also, note that multiple sales forms are not required for frames or receivers of any
    firearms, or pistol grip shotguns, since they are not “pistols or revolvers” under 18 U.S.C 923(g)(3)(A).`,
  },
  {
    question: '25',
    title: `Qualifying Gun Show or Event:`,
    body: ` As defined in 27 CFR 478.100, a gun show or event is a function sponsored by any national, State, 
    or local organization, devoted to the collection, competitive use, or other sporting use of firearms, or 
    an organization or association that sponsors functions devoted to the collection, competitive use, or 
    other sporting use of firearms in the community.`,
  },
  {
    question: '26a',
    title: `Identification:`,
    body: `Before a licensee may sell or deliver a firearm to a nonlicensee, the licensee must establish the 
    identity, place of residence, and age of the transferee/buyer. The transferee/buyer must provide a valid 
    government-issued photo identification document to the transferor/seller that contains the 
    transferee’s/buyer’s name, residence address, and date of birth. A driver’s license or an identification 
    card issued by a State is acceptable. Social Security cards are not acceptable because no address, date 
    of birth, or photograph is shown on the cards.
    <br>
    <br>
    Identification documents such as a driver’s license or identification card issued with binary, non-binary,
    or no sex designation may be used as an identification document. A combination of government-issued
    documents may be provided. See instructions for question 26.b. Supplemental Documentation.
    <br>
    <br>
    If the transferee/buyer is a member of the Armed Forces on active duty acquiring a firearm in the State 
    where his/her permanent duty station is located, but he/she has a driver’s license from another State, the
    transferor/seller must list the transferee’s/buyer’s military identification card in response to question
    26.a., in addition to PCS orders as indicated in 26.c.`,
  },
  {
    question: '26b',
    title: `Supplemental Documentation:`,
    body: `Licensees may accept a combination of valid government-issued documents to satisfy the identification
    document requirements of the law. The required valid government-issued photo identification document bearing 
    the name, photograph, and date of birth of transferee/buyer may be supplemented by another valid, 
    government-issued document showing the transferee’s/buyer’s residence address. This supplemental documentation
    must be recorded in question 26.b., with the issuing authority and type of identification presented. For 
    example, if the transferee/buyer has two States of residence and is trying to buy a handgun in State X, he 
    may provide a driver’s license (showing his name, date of birth, and photograph) issued by State Y and another 
    government-issued document (such as a tax document) from State X showing his residence address. A valid 
    electronic document from a government website may be used as supplemental documentation provided it contains 
    the transferee’s/buyer’s name and current residence address.`,
  },
  {
    question: '26c',
    title: `Official Military Orders Establishing Permanent Change of Station (PCS):`,
    body: `Licensees may accept electronic PCS orders to establish residency.`,
  },
  {
    question: '26d',
    title: `Exceptions to the Nonimmigrant Alien Prohibition:`,
    body: `An alien admitted to the United States under a nonimmigrant visa is not prohibited from purchasing, 
    receiving, or possessing a firearm if the alien: (1) is in possession of a hunting license or permit lawfully 
    issued by the Federal Government, a State or local government, or an Indian tribe federally recognized by the 
    Bureau of Indian Affairs, which is valid and unexpired; (2) was admitted to the United States for lawful hunting 
    or sporting purposes; (3) has received a waiver from the prohibition from the Attorney General of the United 
    States; (4) is an official representative of a foreign government who is accredited to the United States Government 
    or the Government’s mission to an international organization having its headquarters in the United States; (5)
    is an official representative of a foreign government who is en route to or from another country to which that 
    alien is accredited; (6) is an official of a foreign government or a distinguished foreign visitor who has been 
    so designated by the Department of State; or (7) is a foreign law enforcement officer of a friendly foreign 
    government entering the United States on official law enforcement business.`,
  },
  {
    question: '27',
    title: `NICS Background Checks:`,
    body: `18 U.S.C. §922(t) requires that prior to transferring any firearm to an unlicensed person, a licensed 
    importer, manufacturer, or dealer must first contact the National Instant Criminal Background Check System (NICS). 
    NICS will advise the licensee whether the system finds any information that the purchaser is prohibited by law 
    from possessing or receiving a firearm. For purposes of this form, contacts to NICS include State agencies 
    designated as points-of-contact (or POCs) to conduct NICS checks for the Federal Government.
    <br>
    <br>
    The licensee should NOT contact NICS and must stop the transaction if there is reasonable cause to believe that 
    the sale or disposition of a firearm to the transferee/ buyer is prohibited or the transferee/buyer is prohibited 
    from receiving or possessing a firearm, including if: the transferee/buyer answered “no” to questions 21.a; the 
    transferee/buyer answered “yes” to questions 21.b. – 21.1 as well as 21.n.; the transferee/buyer answered “yes” 
    to question 21.m.1., and answered “no” to question 21.m.2.. Warning: Any person who transfers a firearm to any 
    person knowing or having reasonable cause to believe the sale or disposition to such person is prohibited violates 
    the law, 18 U.S.C. §922(d), even if the transferor/seller has complied with the Federal background check requirements
    <br>
    <br>
    <b>NICS Responses:</b> If NICS provides a “proceed” response, the transaction may proceed. If NICS provides a “denied” or 
    “cancelled” (and does not immediately provide a new transaction number) response, the transferor/seller is prohibited 
    from transferring the firearm to the transferee/buyer. If NICS provides a “delayed” response, the transferor/seller 
    is prohibited from transferring the firearm unless 3 business days have elapsed and, before the transfer, NICS or 
    the State has not advised the transferor/seller that the transferee’s/buyer’s receipt or possession of the firearm 
    would be in violation of law. (See 27 CFR 478.102(a) for an example of how to calculate 3 business days.) If NICS 
    provides a “delayed” response, NICS also will provide a Missing Disposition Information (MDI) date that calculates 
    the 3 business days and reflects when the firearm(s) can be transferred under Federal law. States may not provide 
    an MDI date. Some States may not provide a transaction number for denials. However, if a firearm is transferred 
    within the three business day period, a transaction number is required. State law may impose a waiting period or 
    other requirements on transferring firearms.
    <br>
    <br>
    At the time that NICS is contacted, the licensee must record in question 27.a. - 27.c.: the date of contact, the 
    NICS (or State) transaction number, and the initial response provided by NICS or the State. The licensee may record 
    the date the firearms may be transferred to the transferee/buyer (also known as the Missing Disposition Information 
    (MDI) date) in 27.c. that NICS provides for delayed transactions (States may not provide this date). If the licensee 
    receives any subsequent response(s) before transferring the firearm, the licensee must record in question 27.d. any 
    response later provided by NICS or the State, or that no response was provided within 3 business days. If the 
    licensee receives a response from NICS or the State after the firearm has been transferred, he/she must record this 
    information in question 27.e. If the transaction was denied and later overturned, in addition to checking the 
    “Proceed” in 27.d. and entering the date, the licensee must also check “Overturned” and, if provided, attach the 
    overturn certificate issued by NICS or the State POC to this ATF Form 4473. If more than 30 days have elapsed and 
    a new NICS check is required, record the new transaction number, date of contact and the response provided by NICS 
    or the State on this Form 4473 in questions 27.a.-27.c. Note: States acting as points of contact for NICS checks may 
    use terms other than “proceed,” “delayed,” “cancelled,” or “denied.” In such cases, the licensee should check the 
    box that corresponds to the State’s response.`,
  },
  {
    question: '28',
    title: `NICS Exceptions:`,
    body: `A NICS check is not required if the transfer qualifies for any of the exceptions in 27 CFR 478.102(d). 
    Generally these include: (a) transfers of National Firearms Act firearms to an individual who has undergone a 
    background check during the NFA approval process; (b) transfers where the transferee/buyer has presented the 
    licensee with a permit or license that allows the transferee/buyer to possess, acquire, or carry a firearm, and 
    the permit has been recognized by ATF as a valid alternative to the NICS check requirement; or (c) transfers 
    certified by ATF as exempt because compliance with the NICS check requirements is impracticable. If the transfer 
    qualifies for one of these exceptions, the licensee must obtain the documentation required by 27 CFR 478.131. A 
    firearm must not be transferred to any transferee/buyer who fails to provide such documentation.
    <br>
    <br>
    A NICS check must be conducted if an NFA firearm has been approved for transfer to a trust, or to a legal entity 
    such as a corporation, and no background check was conducted as part of the NFA approval process on the individual 
    who will receive the firearm. Individuals who have undergone a background check during the NFA application process 
    are listed on the approved NFA transfer form.`,
  },
  {
    question: '30',
    title: `Transfer on a Different Day and Recertification:`,
    body: ` If the transfer takes place on a different day from the date that the transferee/buyer signed Section B, 
    the licensee must again check the photo identification of the transferee/buyer at the time of transfer.`,
  },
  {
    question: '32',
    title: `For Use by Licensee:`,
    body: `This item is for the licensee’s use in recording any information he/she finds necessary to conduct business 
    or any additional information received from NICS that is not recorded in Questions 27.a. - 27.e.`,
  },
];
